import { orderBy } from 'lodash-es';
import type { ICustomTemplateChart, IState } from './types';

export function getTemplateName(
  state: IState | Record<string, any>,
  templatesList: ICustomTemplateChart[]
): string {
  if (state.templateName) {
    return state.templateName;
  }

  const defaultNames = orderBy(
    templatesList.filter((t) =>
      t.templateName.match(/Untitled\sTemplate\s(\d+)$/g)
    ),
    'templateName',
    'desc'
  );

  if (defaultNames.length) {
    const { templateName } = defaultNames[0];
    const lastTemplateNum = Number(templateName.split(' ').pop());
    return `Untitled Template ${lastTemplateNum + 1}`;
  }

  return 'Untitled Template 1';
}

export function isTemplateValid(state: IState): boolean {
  const { syntaxError, chartError } = state.errors;

  if (!state.template) {
    return false;
  }
  if (chartError || syntaxError) {
    return false;
  }

  return true;
}

function getChartType(template: Highcharts.Options): string {
  if (template?.chart?.type) {
    return template.chart.type;
  }

  if (Array.isArray(template.series)) {
    if (template.series[0].type) {
      return template.series[0].type;
    }
  }

  return 'line';
}

export function templateMapper(
  template: Highcharts.Options
): Highcharts.Options {
  if (!template.chart) {
    template.chart = {
      type: getChartType(template),
    };
  }

  if (template.chart && !template.chart.type) {
    template.chart.type = getChartType(template);
  }

  if (!template.plotOptions) {
    template.plotOptions = {
      [getChartType(template)]: {},
    };
  }

  return template;
}
